import { useEffect } from 'react';
import { useCachedUserType } from 'hooks';
import { UserType } from 'store/api/apiTypes';
import { setUserSource, UserSource } from 'utils/mixpanel';

const isStandalone = process.env.REACT_APP_TYPE === 'standalone';

const getUserSource = (userType: UserType | null): UserSource | null => {
  if (!isStandalone) {
    return 'XOVI';
  }
  switch (userType) {
    case 'ka':
      return 'Partner';
    case 'direct':
      return 'Standalone';
    default:
      return null;
  }
};

export const UserSourceTracker: React.FC = () => {
  const { userType } = useCachedUserType();
  const source = getUserSource(userType);

  useEffect(() => {
    if (source) {
      setUserSource(source);
    }
  }, [source]);

  return null;
};
